































































import Vue from "vue";

const colors = [
  "#7f0000",
  "#cc0000",
  "#ff4444",
  "#ff7f7f",
  "#ffb2b2",
  "#995100",
  "#cc6c00",
  "#ff8800",
  "#ffbb33",
  "#2c4c00",
  "#436500",
  "#669900",
  "#99cc00",
  "#3c1451",
  "#6b238e",
  "#9933cc",
  "#aa66cc",
  "#bc93d1",
  "#004c66",
  "#0099cc",
  "#33b5e5",
  "#8ed5f0",
  "#660033",
  "#b20058",
  "#e50072",
  "#ff3298",
  "#ff7fbf"
];
export default Vue.extend({
  name: "Competences",

  data: () => ({}),

  methods: {
    getTechSkills() {
      const items = [
        {
          competence: "details.java",
          rate: 85
        },
        {
          competence: "details.nestjs",
          rate: 70
        },
        {
          competence: "details.quarkus",
          rate: 40
        },
        {
          competence: "details.vuejs",
          rate: 75
        },
        {
          competence: "details.angular",
          rate: 60
        },
        {
          competence: "details.openshift",
          rate: 65
        },
        {
          competence: "details.hibernate",
          rate: 80
        },
        {
          competence: "details.docker",
          rate: 50
        },
        {
          competence: "details.cicd",
          rate: 60
        },
        {
          competence: "details.couchbase",
          rate: 65
        }
      ];
      return items;
    },

    getOtherSkills() {
      const items = [
        {
          competence: "details.scrum",
          rate: 80
        },
        {
          competence: "details.scrummaster",
          rate: 60
        },
        {
          competence: "details.ux",
          rate: 40
        },
        {
          competence: "details.teamSpirit",
          rate: 90
        },
        {
          competence: "details.audacity",
          rate: 75
        },
        {
          competence: "details.curiosity",
          rate: 80
        },
        {
          competence: "details.entrepeneurShip",
          rate: 85
        }
      ];
      return items;
    },

    getRandomColor() {
      return colors[
        Math.floor(Math.random() * (colors.length - 1 - 0 + 1) + 0)
      ];
    }
  }
});
